import type { ResourceCategory } from '@/mocks/resources';

interface FooterProps {
  categories: ResourceCategory[];
}

const Footer = ({ categories }: FooterProps) => {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-0 bg-primary-950 text-background-200">
      <div className="mx-auto grid max-w-7xl grid-cols-2 gap-8 px-4 py-12 md:grid-cols-4 md:px-6">
        <div className="col-span-2 md:col-span-1">
          <a href="#top" className="flex items-center gap-2">
            <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-compass-3-line text-lg" aria-hidden="true" />
            </span>
            <span className="font-heading text-xl font-bold text-background-50">51全网</span>
          </a>
          <p className="mt-3 text-xs leading-6 text-background-200/90">
            按分类汇总的资源聚合与工具导航平台。集中展示工具网站、模板资源与常用资源集合，
            打开即查，一键收藏。
          </p>
          <div className="mt-4 flex items-center gap-2 text-xs text-background-200/80">
            <i className="ri-mail-line text-sm" aria-hidden="true" />
            nav@example.com
          </div>
        </div>

        <nav aria-label="分类页脚">
          <p className="text-sm font-bold text-background-50">热门分类</p>
          <ul className="mt-3 space-y-2 text-xs">
            {categories.slice(0, 5).map((c) => (
              <li key={c.id}>
                <a href={`#${c.id}`} className="text-background-200/85 hover:text-background-50">
                  {c.name}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <nav aria-label="更多分类页脚">
          <p className="text-sm font-bold text-background-50">更多分类</p>
          <ul className="mt-3 space-y-2 text-xs">
            {categories.slice(5).map((c) => (
              <li key={c.id}>
                <a href={`#${c.id}`} className="text-background-200/85 hover:text-background-50">
                  {c.name}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <nav aria-label="快速入口页脚">
          <p className="text-sm font-bold text-background-50">快速入口</p>
          <ul className="mt-3 space-y-2 text-xs">
            <li><a href="#top" className="text-background-200/85 hover:text-background-50">回到顶部</a></li>
            <li><a href="#faq" className="text-background-200/85 hover:text-background-50">常见问题</a></li>
            <li><a href="#about" className="text-background-200/85 hover:text-background-50">关于我们</a></li>
            <li>
              <a href="mailto:nav@example.com" rel="nofollow" className="text-background-200/85 hover:text-background-50">
                推荐收录资源
              </a>
            </li>
          </ul>
        </nav>
      </div>

      <div className="border-t border-background-100/10">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-background-200/70 sm:flex-row md:px-6">
          <p>© {year} 51全网 · 免费开放的资源聚合与工具导航</p>
          <p className="flex items-center gap-1">
            <i className="ri-leaf-line text-sm" aria-hidden="true" />
            仅供收录导航与信息整理，请遵守各资源授权条款
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;